import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { defaultInAppBrowserConfig } from "../../components/m-iframe/defaultInAppBrowserConfig";
import { InAppBrowserOptions } from "../../components/m-iframe/model/inAppBrowserOptions";

@Injectable({
  providedIn: "root",
})
export class ExternalLinkManageService {
  isMobile = environment.mobile;
  defaultOptions: InAppBrowserOptions = defaultInAppBrowserConfig;

  constructor() { }

  openLink(url: string, options?: InAppBrowserOptions): void {
    if (!!this.isMobile && !!window.cordova) {
      const optionStr = !!options
        ? this.optionObjectToString(options)
        : this.optionObjectToString(this.defaultOptions);
      cordova.InAppBrowser.open(url, url.includes('mailto') ? '_system' : "_blank", optionStr);
    } else {
      window.open(url, "_blank");
    }
  }

  private optionObjectToString(options: InAppBrowserOptions): string {
    return options
      ? Object.keys(options)
        .map((el) => `${el}=${options[el]}`)
        .join(",")
      : "";
  }
}
